import { render } from "./UpdateTemplateIsoPermissions.vue?vue&type=template&id=117ad4e8&scoped=true"
import script from "./UpdateTemplateIsoPermissions.vue?vue&type=script&lang=js"
export * from "./UpdateTemplateIsoPermissions.vue?vue&type=script&lang=js"

import "./UpdateTemplateIsoPermissions.vue?vue&type=style&index=0&id=117ad4e8&scoped=true&lang=scss"

import exportComponent from "/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-117ad4e8"]])

export default __exports__